import { useState } from 'react';
import { DatePicker } from '../../../../components/DatePicker';
import { Dialog } from '../../../../components/Dialog';
import { Flow } from '../../../../components/Layouts/Flow';
import { useMessageDialogText } from '../../../../components/MessageDialog';
import { withLabels } from '../../../../components/withLabels';
import { createUseTextLocalizer } from '../../../../locale/createUseTextLocalizer';
import { postfixTestId } from '../../../../util/testId';
import bundle from '../../NovaComponents-CatalogSearch-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DatePickerWithLabels = withLabels(DatePicker);
const useTextLocalizer = createUseTextLocalizer(bundle);
export const DateRangeSelectorDialog = ({
  onOk,
  onCancel,
  testId
}) => {
  const localize = useTextLocalizer();
  const {
    CANCEL,
    OK
  } = useMessageDialogText();
  const ONE_WEEK_MS = 1000 * 60 * 60 * 24 * 7;
  const [startDate, setStartDate] = useState(new Date(Date.now() - ONE_WEEK_MS));
  const [endDate, setEndDate] = useState(new Date(Date.now()));
  const [startMaxDate, setStartMaxDate] = useState(endDate);
  const [endMinDate, setEndMinDate] = useState(startDate);
  const dateRangeDialogPrimaryAction = {
    text: OK,
    isDefault: true,
    disabled: false,
    onPress: () => {
      onOk(startDate, endDate);
    }
  };
  const dateRangeDialogDismissAction = {
    text: CANCEL,
    onPress: () => {
      onCancel();
    }
  };
  return /*#__PURE__*/_jsx(Dialog, {
    resizable: false,
    size: {
      width: 200
    },
    isOpen: true,
    title: localize('datePicker.dialog.title'),
    firstAction: dateRangeDialogPrimaryAction,
    dismissAction: dateRangeDialogDismissAction,
    testId: postfixTestId(testId, 'dialog'),
    children: /*#__PURE__*/_jsxs(Flow, {
      orientation: "vertical",
      spacing: "m",
      children: [/*#__PURE__*/_jsx(DatePickerWithLabels, {
        labelPosition: 'top',
        label: localize('datePicker.startDate.label'),
        value: startDate,
        maxDate: startMaxDate,
        onChange: newDate => {
          if (!!newDate.value) {
            setStartDate(newDate.value);
            setEndMinDate(newDate.value);
          }
        },
        testId: postfixTestId(testId, 'startdatepicker'),
        required: true
      }), /*#__PURE__*/_jsx(DatePickerWithLabels, {
        label: localize('datePicker.endDate.label'),
        labelPosition: 'top',
        value: endDate,
        minDate: endMinDate,
        maxDate: new Date(Date.now()),
        onChange: newDate => {
          if (!!newDate.value) {
            setEndDate(newDate.value);
            setStartMaxDate(newDate.value);
          }
        },
        testId: postfixTestId(testId, 'enddatepicker'),
        required: true
      })]
    })
  });
};
//# sourceMappingURL=DateRangeSelectorDialog.js.map